<template>
  <div class="page">
        <!-- 搜索 -->
  <div class="page-content">
      <div class="content">
          <div v-for="(item,index) in modelPlaceList" :key="index" class="item">
              <div class="top">
                  <MgJzD :typeId="item.dictType" style="margin-left: 3px;"></MgJzD>
                  <span
                      class="icon-box"
                      :title="'安置介绍：' + item.placeIntro"
                      style="margin-left: 8px;cursor: pointer"
                  >
<!--                      <Icon color="#606266">-->
<!--                        <Refresh />-->
<!--                      </Icon>-->
                      <i class="el-icon-info" style="color: #606266;"></i>
                    </span>
              </div>
              <div class="center">
<!--                 <i class="el-icon-question" style="width: 42px;height: 42px;font-size: 42px;margin-right: 8px;color: #2d8cf0"></i>-->
                  <span>
                      {{item.placeName}}
                  </span>
              </div>
              <div class="bottom">
                  <el-switch
                      v-model="item.isActive"
                      active-color="#13ce66"
                      :active-value="1"
                      :inactive-value="0"
                      inactive-color="#ff4949">
                  </el-switch>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlaceUI.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelPlaceList();
                    this.getModelPlaceList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelPlaceList();
                    this.getModelPlaceList();
                    this.$emit('resetCheckState');
                }
            },
            names: {
                handler(newNames, oldNames) {
                    if(JSON.stringify(oldNames) == '[]'){
                        return
                    }
                    newNames.forEach((name, index) => {
                        if (name !== oldNames[index]) {
                            console.log(`Active of item at index ${index} changed to ${name}`);
                            post(`/model/place/edit`,this.modelPlaceList[index] ).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelPlaceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                    this.modelPlaceList[index].isActive = oldNames[index];
                                }
                            });
                        }
                    });
                },
                deep: true,
                immediate: false,
            },
        },
    computed: {
        names() {
            return this.modelPlaceList.map(item => item.isActive);
        },
    },
    data() {
            return {
                queryForm:{
                     placeName: '', //安置名称
                     placeType: '', //安置类型
                     isActive: '', //是否激活
                     dictType: '', //字典类型
                     placeIntro: '', //安置介绍
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelPlaceState: 'add',
                modelPlaceStates: {
                    add: '新建安置',
                    check: '查看安置',
                    edit: '修改安置'
                },

                multipleSelection: [],
                modelPlaceList: [],
                modelPlace: {
                    id: '', //ID
                    placeName: '', //安置名称
                    placeType: '', //安置类型
                    isActive: '', //是否激活
                    dictType: '', //字典类型
                    placeIntro: '', //安置介绍
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    placeName: [{ required: true, message: '安置名称不能为空', trigger: 'blur' }],
                    placeType: [{ required: true, message: '安置类型不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    placeIntro: [{ required: true, message: '安置介绍不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                auditStatus:[],
            };
        },
        created() {
            this.getModelPlaceList();
            this.getAuditStatus();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getAuditStatus() {
                get('/mpp/utils/getEnum', { enumType: 'model_place_type' }).then((res) => {
                    this.auditStatus = res.enumList;
                });
            },
            computeAuditStatus(type){
                for (let i = 0; i < this.auditStatus.length; i++) {
                    if(this.auditStatus[i].key == type){
                        return this.auditStatus[i].value
                    }
                }
            },
            resetModelPlaceList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelPlaceList = [];
            },
            resetDialog() {
                this.modelPlaceState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      placeName: '', //安置名称
                      placeType: '', //安置类型
                      isActive: '', //是否激活
                      dictType: '', //字典类型
                      placeIntro: '', //安置介绍
                };
                this.getModelPlaceList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelPlace = {
                      id: '', //ID
                      placeName: '', //安置名称
                      placeType: '', //安置类型
                      isActive: '', //是否激活
                      dictType: '', //字典类型
                      placeIntro: '', //安置介绍
                };
            },
            submitForm() {
                if (this.modelPlaceState == 'add') {
                    this.$refs.modelPlaceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/place/add`,{ ...this.modelPlace }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelPlaceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelPlaceState == 'edit') {
                    this.$refs.modelPlaceForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/place/edit`,{ ...this.modelPlace }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelPlaceList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelPlace() {
                this.showDialog = true;
                this.modelPlaceState = 'add';
            },
            checkModelPlace(modelPlaceId) {
                console.log(modelPlaceId);
                this.currentModelPlaceId = modelPlaceId;

                this.getModelPlaceById();
                this.showDialog = true;
                this.modelPlaceState = 'check';
            },
            editModelPlace(modelPlaceId) {
                console.log('modelPlace', modelPlaceId);
                if (modelPlaceId) {
                    this.currentModelPlaceId = modelPlaceId;
                    this.getModelPlaceById();
                } else {
                    this.modelPlace = { ...this.modelPlace, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelPlaceState = 'edit';
            },
            deleteModelPlace(modelPlaceId) {
                let ids = '';
                if (modelPlaceId) {
                    ids = modelPlaceId;
                } else {
                    ids = this.multipleSelection.map((modelPlace) => modelPlace.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/place/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelPlaceList();
                                this.getModelPlaceList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelPlaceList() {
                this.resetModelPlaceList();
                this.getModelPlaceList();
            },
            getModelPlaceList(query = {}) {
                this.loading = true;
                get(`/model/place/findAll`).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelPlaceList = res.list;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelPlaceById() {
                get(`/model/place/get`,{ id: this.currentModelPlaceId }).then((res) =>{
                    if(res.success){
                      this.modelPlace = { ...this.modelPlace, ...res.modelPlace };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelPlaceList() {
                //this.btnLoading = true;
                exprotExcel(`/model/place/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/place/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/place/importData`,formData);
              this.refreshModelPlaceList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelPlaceList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelPlaceList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.content{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    .item{
        width: 180px;
        height: 120px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        border-radius: 8px;
        padding: 10px;
        margin-left: 15px;
        margin-bottom: 15px;
        .top{
            display: flex;
            justify-content: flex-end;
            align-content: center;
            align-items: center;
        }
        .center{
            margin-top: 4px;
            height: 42px;
            display: flex;
            span{
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                font-size: 14px;
            }
        }
        .bottom{
            margin-top: 4px;
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>